import { Component } from "../../../../modules/Core/Component";
import templateDefault from "../../../templates/default/widgets/sliders/images-gallery";
import Services from "../../../Services/Services";

export default class ImagesGallery extends Component {
  id = "images-gallery";

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.getSliders();
  }

  getSliders() {
    this.setData({ "default.slidersLoaded": false });

    Services.get("hook").then(async ([hookService]) => {
      try {
        var response = await hookService.exec("sliders", {
          params: { scope: this.props.fscope },
        });

        const sliders = response.getData() || [];

        this.setData({
          "default.sliders": sliders,
          "default.slidersLoaded": true,
        });
      } catch (e) {
        console.log(e);
        this.setData({
          "default.sliders": [],
          "default.slidersLoaded": true,
        });
      }
    });
  }
}
